import { useLocation } from 'react-router-dom';
import { getElixirUrl } from '@components/common/customer-welcome-modal';
import css from './index.module.scss';

const ITEMS = [
  { text: 'We have a new & updated platform waiting for you!', bold: true },
  { text: 'Track shipment & order status anytime', bold: false },
  { text: 'Reduce dependency on email follow-ups', bold: false },
  { text: 'View documents & stuffing photos in one centralized place', bold: false },
  { text: 'View our product catalogue along with specifications & more', bold: false }
];

const Separator = () => (
  <span className={css.separator} aria-hidden="true">
    <svg width="10" height="10" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 0.5L7.03 4.47L11 5.5L7.03 6.53L6 10.5L4.97 6.53L1 5.5L4.97 4.47L6 0.5Z"
        fill="#d50600"
      />
    </svg>
  </span>
);

const TickerContent = () => (
  <>
    {ITEMS.map((item, i) => (
      <span key={i} className={css.itemGroup}>
        <span className={item.bold ? css.itemBold : css.item}>{item.text}</span>
        <Separator />
      </span>
    ))}
  </>
);

const ElixirTicker = () => {
  const location = useLocation();
  const elixirUrl = getElixirUrl(location.pathname, new URLSearchParams(location.search));

  const handleClick = () => {
    window.open(elixirUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div
      className={css.ticker}
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={(e) => e.key === 'Enter' && handleClick()}
      aria-label="Explore Elixir 2.0"
    >
      <div className={css.track}>
        <TickerContent />
        <TickerContent />
      </div>
    </div>
  );
};

export default ElixirTicker;
